import { useEffect, useState } from "react";
import AmrMeterGroup from "../amr-meter-group/amr-meter-group";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./stock-view.scss";
import { useDispatch, useSelector } from "react-redux";
import NewFlavorsPopup from "../new-flavors-popup/new-flavors-popup";
import OtherTable from "../other-table/other-table";
import PreviewTable from "../preview-table/preview-table";
import DataFiltersRow, { DataFiltersRowType } from "../data-filters-row/data-filters-row";

const StockView = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const ic_products = useSelector((state: any) => state.product.cumulative_ic_products);
  const op_products = useSelector((state: any) => state.product.cumulative_op_products);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const selectedShop = useSelector((state: any) => state.user.selectedShop);
  const [productType, setProductType] = useState(null);
  const hasICProducts = ic_products && ic_products.length > 0;
  const global_total_liters = ic_products?.reduce((accumulator ,item) => {
    return accumulator += item.total_liters;
    }, 0)
  
  const global_three_liter = ic_products?.reduce((accumulator ,item) => {
      return accumulator += item.three_liter;
    }, 0)
  const global_five_liter = ic_products?.reduce((accumulator ,item) => {
      return accumulator += item.five_liter;
    }, 0)
  const global_seven_liter = ic_products?.reduce((accumulator ,item) => {
      return accumulator += item.seven_liter;
    }, 0)
  
  const meterGroupValues = [{ label: '7L pack', value: global_seven_liter, color: '#5FC9CA' }, { label: '5L pack', value: global_five_liter, color: '#6C1EF269' }, { label: '3L pack', value: global_three_liter, color: '#6B18C33B' }];

  const headersIC = [
    { field: 'name', header: 'Flavors', style:'bold' },
    { field: 'seven_liter', header: '7L PACK', style:'' },
    { field: 'five_liter', header: '5L PACK', style:'' },
    { field: 'three_liter', header: '3L PACK', style:'' },
    { field: 'total_quantity', header: 'Total products', style:'bold' },
    { field: 'total_liters', header: 'Total in liters', style:'bold' }
  ];
  const headersOP = [
    { field: 'name', header: 'PRODUCTS', style:'bold' },
    { field: 'type', header: 'TYPE', style:'' },
    { field: 'pack_count', header: 'NUMBER OF PACKS', style:'' },
    { field: 'pack_size', header: 'PACK SIZE', style:'' },
    { field: 'total_quantity', header: 'TOTAL', style:'bold' },
  ];
  return (
    <div className='stock-view'>
        <PageHierarchy />
        <DataFiltersRow dateSelector={'single'} setExternalProductType={setProductType} productType={productType} type={DataFiltersRowType.STOCK_VIEW}/>
        {hasICProducts && <AmrMeterGroup values={meterGroupValues} />}
        <div style={{height:'45vh'}}>
          <PreviewTable objectList={ic_products??op_products} headers={ic_products?headersIC:headersOP}/>
        </div>
        {isPopupOpen && (
          <NewFlavorsPopup fullCommentary="fff" isVisible={isPopupOpen} setVisible={setIsPopupOpen} />
        )}
    </div>
  );
};

export default StockView;
